<template>
	<div>
	  <Header title="评价结果查询"></Header>
	  <div class="classTable">
		<van-field
		  v-model="xnxq.mc"
		  label="学年学期"
		  right-icon="arrow"
		  input-align="right"
		  placeholder="请点击选择"
		  @click="showPop('学年学期', 'xnxq')"
		  readonly
		/>
	  </div>
	  <div class="bottom-btn" @click="search">
		<button>查询</button>
	  </div>
    <van-popup v-model="show" round position="bottom">
		<van-picker
		  :title="valueList.label"
		  show-toolbar
		  :columns="valueList.item"
		  @cancel="show = false"
		  @confirm="
			(value, index) => {
			  onConfirm(value, index);
			}
		  "
	  /></van-popup>
	</div>
  </template>

  

<script>
import { Api } from '../../../utils/axios';
import Vue from "vue";
import { Picker } from "vant";

Vue.use(Picker);
export default {
  data() {
    return {
      active: 0,
      title: "",
      show: false,
      show1: false,
      xnxq: {
        mc:'',
        dm:''
      },
      columns: {
        xnxq: []
      },
      valueList: {
        label: "",
        value: "",
        item: ""
      },
    };
  },
  methods: {
    search() {
      if (this.xnxq.dm == '') {
        this.$toast("请选择学年学期");
        return;
      }
      const params = {
        xnxqId: this.xnxq.dm
      };
      this.$router.push({
        name: "pjjgcxList",
        params: {
          route_params: encodeURI(JSON.stringify(params))
        }
      });
    },
    // 关闭联动框
    close() {
      this.active = 0;
    },
    async getList() {
	  const res = await Api.getpjjgQuery();
      // 获取学年学期
      this.getXnxq(res.data);
    },
    // 获取学年学期
    getXnxq(data) {
      this.columns.xnxq = data.map(item => {
        return {
          text: item.xqmc,
          value: item.xnxq01id
        };
      });
    },
    showPop(label, value) {
      this.show = true;
      this.valueList.label = label;
      this.valueList.value = value;
      this.valueList.item = this.columns[value];
    },
    
    onConfirm(value) {
      let value1 = this.valueList.value;
      this.show = false;
      this[value1].mc = value.text;
      this[value1].dm = value.value;
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="less">
.classTable {
  padding: 5% 5% 0;

  .van-cell {
    padding: 10px 0;
    border-bottom: 1px solid #f4f4f4;
  }
  .van-cell::after {
    display: none;
  }
  .van-field__label {
    width: 7.2em;
  }
  .van-cell.van-field .van-cell__title.van-field__label > span {
    font-family: PingFangSC-Light;
    font-size: 16px;
    color: #212f6e;
    letter-spacing: 0;
  }
  .van-field__control::-webkit-input-placeholder {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #dfe0e6 !important;
    letter-spacing: 0;
    font-weight: normal;
    text-align: right;
  }
  .van-field__control::-moz-input-placeholder {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #dfe0e6 !important;
    font-weight: normal;
    letter-spacing: 0;
    text-align: right;
  }
  .van-field__control::-ms-input-placeholder {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #dfe0e6 !important;
    letter-spacing: 0;
    font-weight: normal;
    text-align: right;
  }
  .van-field__control {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #212f6e;
    letter-spacing: 0;
    text-align: right;
    font-weight: bolder;
  }
  .van-icon-arrow {
    color: #dfe0e6;
    font-weight: bolder;
    font-size: 14px;
  }
}
.bottom-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  padding-bottom: 10px;
  padding: 0 5%;
  background: #fff;
  box-sizing: border-box;

  button {
    width: 100%;
    height: 44px;
    background: #7469f8;
    border-radius: 3px;
    color: #fff;
  }
}
.more.van-popup.van-popup--bottom {
  border-radius: 0 !important ;
}
.more {
  padding: 5% 0 5% 0;
  box-sizing: border-box;
  overflow: hidden;
  .van-tabs__content--animated {
    height: 75vh;
    overflow: auto;
  }
  .van-tabs--line .van-tabs__wrap {
    border-bottom: 1px solid #f4f4f4;
    .van-tab--active {
      .van-tab__text--ellipsis {
        color: #212f6e !important;
      }
    }
    .van-tab__text--ellipsis {
      height: 20px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #8f95b5;
      text-align: center;
      letter-spacing: 0;
    }
    .van-tabs__line {
      background-color: #7469f8 !important;
      width: 25px;
      height: 3px;
      border-radius: 1.5px;
    }
  }
  & > p {
    width: 64px;
    font-weight: bolder;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    text-align: center;
    padding-left: 7%;
  }
  ul {
    overflow: auto;
    height: 36vh;
    .choose {
      background-color: #f8f8f8;
    }
    li {
      height: 40px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #212f6e;
      font-weight: bold;
      display: flex;
      align-items: center;
      padding-right: 5%;
      padding-left: 7%;
      justify-content: space-between;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/pjjgcx/pjjgcxQuery.vue